export default {
  sm: `
  The photos, videos, and documents we upload make their ways to the internet, passing through the network of different providers. The data gathered on the internet goes through a variety of network equipment to become stored in data centers.
  `
};
